import { ClassChildFactory } from './classChildFactory';

import type {
  ClassChildEntity,
  ClassChildPropsPub,
  ClassChildPropsPvt,
} from './classChildEntity';
import type { ClassChildIRepository } from './classChildIRepository';
import type { EntityDataPubType } from '@/infra/appsync';
import type { ClassChildJsonPub, ClassChildJsonPvt } from '@/types/domain/class/entities/classChildEntity';

import { AppsyncRepository } from '@/domain/appsyncRepository';
import {
  EntityName,
} from '@/infra/appsync';

export class ClassChildRepository extends AppsyncRepository<
  ClassChildEntity,
  ClassChildPropsPvt,
  ClassChildJsonPvt,
  ClassChildPropsPub,
  ClassChildJsonPub
> implements ClassChildIRepository {
  private factory = new ClassChildFactory();

  protected get entityName(): EntityName {
    const name: EntityName = EntityName.WagakoNurseryClassClassChildEntity;
    return name;
  }

  /**
   * DBデータをEntityに変換
   * @param props DBデータ
   * @returns Entity
   */
  protected createFromEntityType = (
    props: EntityDataPubType,
  ) => this.factory.createFromEntityType(props);
}
